// extracted by mini-css-extract-plugin
export default {"main":"Bio_main__YD3Qg","bio_h2":"Bio_bio_h2__jX914"};